<script setup>
import PostSaleCaseDetail from './PostSaleCaseDetail.vue';

defineProps({
  postSale: { type: Object, required: true },
});

const emit = defineEmits([
  'assign',
  'change-status',
  'close-note-form',
  'close',
  'create-note',
  'delete-note',
  'edit-note',
  'edit-topic',
  'open-analysis',
  'request-correction',
  'request-nucleo',
  'save-note',
  'update-responsible',
]);
</script>

<template>
  <PostSaleCaseDetail
    v-if="postSale.selectedCase.value"
    :agents="postSale.agents.value"
    :case-data="postSale.selectedCase.value"
    :editing-note="postSale.editingNote.value"
    :loading="postSale.loadingDetail.value"
    :loading-notes="postSale.loadingNotes.value"
    :loading-topics="postSale.loadingTopics.value"
    :note-saving="postSale.savingNote.value"
    :notes="postSale.notes.value"
    :responsible-user-id="postSale.responsibleUserId.value"
    :show-note-form="postSale.showNoteForm.value"
    :show="Boolean(postSale.routePostSaleCaseId.value)"
    :topics="postSale.topics.value"
    @assign="emit('assign', $event)"
    @change-status="emit('change-status')"
    @close-note-form="emit('close-note-form')"
    @close="emit('close')"
    @create-note="emit('create-note')"
    @delete-note="emit('delete-note', $event)"
    @edit-note="emit('edit-note', $event)"
    @edit-topic="emit('edit-topic', $event)"
    @open-analysis="emit('open-analysis')"
    @request-correction="emit('request-correction')"
    @request-nucleo="emit('request-nucleo')"
    @save-note="emit('save-note', $event)"
    @update:responsible-user-id="emit('update-responsible', $event)"
  />
  <span v-else class="hidden" aria-hidden="true" />
</template>
